var $078463d69a051bef$exports = {};
// Promo nchova, caricato su tutte le pagine dai partial consent-and-tags-head*. Solo
// sui Mac (data-promo-platform, scritto dallo script in linea dello stesso partial)
// fa nuotare i pesci e gestisce i pulsanti "Copia il codice" dello sconto riservato
// agli utenti Stipendee.
//
// Volutamente senza import né export, come js/trackedLinks.js: un entry ESM nel <head>
// in sviluppo chiede a Parcel un helper che sta in un bundle caricato più tardi
// ("Cannot find module"), e se è anche condiviso con altri entry rompe la build.
const $078463d69a051bef$var$isMac = document.documentElement.dataset.promoPlatform === 'macos';
// ===== Il transcript sullo sfondo del banner =====
// Le battute stanno in data-lines (JSON, generato da scripts/build-promo-partial.js) e
// diventano DOM solo qui, nel browser: così non compaiono nell'HTML servito come testo
// della pagina, che è quello che leggono i motori di ricerca. Decorativo, aria-hidden.
for (const field of document.querySelectorAll('.nchova-banner__field[data-lines]')){
    let lines = [];
    try {
        lines = JSON.parse(field.dataset.lines);
    } catch  {
        lines = [];
    }
    for (const [time, who, said] of lines){
        const span = document.createElement('span');
        span.append(`${time} `);
        const b = document.createElement('b');
        b.textContent = who;
        span.append(b, ` ${said}`);
        field.append(span);
    }
}
// ===== Il pesce di nchova che nuota =====
// Porting di src/scripts/fish del sito nchova-web (mark.ts, element.ts, swimmer.ts,
// ticker.ts), numeri compresi: il marchio è un pesce visto di lato (la graffa è la
// coda, le quattro barre le costole, l'arco la testa) e il piano su cui è disegnato
// si piega come la linea mediana di un pesce.
//
// <nchova-fish size="22">  nuota sul posto, come nelle pillole dell'app.
//                          Attributi: size (altezza in px), bones, ribs (colori), still.
// <nchova-tank fish="2">   riempie il contenitore con pesci che girano e scappano dal
//                          puntatore. Attributi: fish (quanti), size (altezza del più grande).
//
// Dentro gli elementi può stare un SVG statico del marchio: resta visibile finché
// l'elemento non è definito (CSS :defined) e senza JavaScript.
const $078463d69a051bef$var$INK = {
    deep: '#796cbf',
    violet: '#9184d9',
    lilac: '#d2cefd'
};
const $078463d69a051bef$var$STROKE = 54;
const $078463d69a051bef$var$RIB_WIDTH = 42;
const $078463d69a051bef$var$RIBS = [
    [
        342,
        130
    ],
    [
        430,
        230
    ],
    [
        518,
        300
    ],
    [
        606,
        210
    ]
];
// L'inchiostro del marchio, più lo spazio che serve a un pezzo quando si avvicina.
const $078463d69a051bef$var$BOX = {
    x: 160,
    y: 270,
    w: 695,
    h: 484
};
// Il centro dell'inchiostro: quello che gira e si muove.
const $078463d69a051bef$var$CENTRE = {
    x: 507,
    y: 512
};
function $078463d69a051bef$var$cubic(out, p0, c1, c2, p1, n) {
    for(let i = 1; i <= n; i++){
        const t = i / n;
        const u = 1 - t;
        out.push([
            u * u * u * p0[0] + 3 * u * u * t * c1[0] + 3 * u * t * t * c2[0] + t * t * t * p1[0],
            u * u * u * p0[1] + 3 * u * u * t * c1[1] + 3 * u * t * t * c2[1] + t * t * t * p1[1]
        ]);
    }
}
function $078463d69a051bef$var$line(out, p0, p1, n) {
    for(let i = 1; i <= n; i++){
        const t = i / n;
        out.push([
            p0[0] + (p1[0] - p0[0]) * t,
            p0[1] + (p1[1] - p0[1]) * t
        ]);
    }
}
// La graffa: due estremi a sinistra, la punta che tocca il corpo a destra.
const $078463d69a051bef$var$TAIL = (()=>{
    const p = [
        [
            204,
            362
        ]
    ];
    $078463d69a051bef$var$cubic(p, [
        204,
        362
    ], [
        240,
        362
    ], [
        246,
        376
    ], [
        246,
        406
    ], 6);
    $078463d69a051bef$var$line(p, [
        246,
        406
    ], [
        246,
        474
    ], 4);
    $078463d69a051bef$var$cubic(p, [
        246,
        474
    ], [
        246,
        498
    ], [
        254,
        506
    ], [
        272,
        512
    ], 5);
    $078463d69a051bef$var$cubic(p, [
        272,
        512
    ], [
        254,
        518
    ], [
        246,
        526
    ], [
        246,
        550
    ], 5);
    $078463d69a051bef$var$line(p, [
        246,
        550
    ], [
        246,
        618
    ], 4);
    $078463d69a051bef$var$cubic(p, [
        246,
        618
    ], [
        246,
        648
    ], [
        240,
        662
    ], [
        204,
        662
    ], 6);
    return p;
})();
const $078463d69a051bef$var$HEAD = (()=>{
    const p = [
        [
            700,
            342
        ]
    ];
    $078463d69a051bef$var$cubic(p, [
        700,
        342
    ], [
        766.9,
        372.1
    ], [
        810,
        438.6
    ], [
        810,
        512
    ], 14);
    $078463d69a051bef$var$cubic(p, [
        810,
        512
    ], [
        810,
        585.4
    ], [
        766.9,
        651.9
    ], [
        700,
        682
    ], 14);
    return p;
})();
// Una costola come contorno: uno stadio, campionato perché ogni punto si possa muovere da solo.
function $078463d69a051bef$var$ribOutline(x, height) {
    const r = $078463d69a051bef$var$RIB_WIDTH / 2;
    const cx = x + r;
    const top = 512 - height / 2 + r;
    const bottom = 512 + height / 2 - r;
    const p = [];
    const arc = (cy, from)=>{
        for(let i = 0; i <= 8; i++){
            const a = from + Math.PI * i / 8;
            p.push([
                cx + r * Math.cos(a),
                cy + r * Math.sin(a)
            ]);
        }
    };
    arc(top, Math.PI);
    $078463d69a051bef$var$line(p, p[p.length - 1], [
        cx + r,
        bottom
    ], 4);
    arc(bottom, 0);
    $078463d69a051bef$var$line(p, p[p.length - 1], [
        cx - r,
        top
    ], 4);
    return p;
}
const $078463d69a051bef$var$RIB_OUTLINES = $078463d69a051bef$var$RIBS.map(([x, h])=>$078463d69a051bef$var$ribOutline(x, h));
// Secondi per colpo di coda: l'app a riposo ne fa uno ogni 2,8.
const $078463d69a051bef$var$IDLE = {
    period: 2.8,
    vigour: 1,
    elevation: 14
};
const $078463d69a051bef$var$NOSE = 837;
const $078463d69a051bef$var$LENGTH = 660;
const $078463d69a051bef$var$SAMPLES = 66;
// Lunghezze del corpo per onda, fra lo 0,75 di un'anguilla e l'1,14 di un tonno.
const $078463d69a051bef$var$WAVELENGTH = 0.95;
// Distanza dell'occhio: una coda che si avvicina di un decimo del corpo cresce di un decimo.
const $078463d69a051bef$var$EYE = 700;
// Un istante del colpo di coda: la linea mediana del pesce dal muso alla fine della coda.
class $078463d69a051bef$var$Midline {
    constructor(){
        this.xs = new Float64Array($078463d69a051bef$var$SAMPLES + 1);
        this.depths = new Float64Array($078463d69a051bef$var$SAMPLES + 1);
        this.lift = 0;
    }
    set(phase, vigour = 1, elevation = 14) {
        const { xs: xs, depths: depths } = this;
        this.lift = Math.sin(elevation * Math.PI / 180);
        const step = $078463d69a051bef$var$LENGTH / $078463d69a051bef$var$SAMPLES;
        const k = 2 * Math.PI / $078463d69a051bef$var$WAVELENGTH;
        xs[0] = $078463d69a051bef$var$NOSE;
        depths[0] = 0;
        for(let i = 0; i < $078463d69a051bef$var$SAMPLES; i++){
            // Metà dell'escursione laterale a u lunghezze dal muso, e la pendenza dell'onda lì.
            const u = (i + 0.5) / $078463d69a051bef$var$SAMPLES;
            const reach = (0.05 - 0.13 * u + 0.28 * u * u) / 2;
            const grows = (-0.13 + 0.56 * u) / 2;
            const turn = Math.atan(vigour * (grows * Math.sin(k * u - phase) + reach * k * Math.cos(k * u - phase)));
            xs[i + 1] = xs[i] - step * Math.cos(turn);
            depths[i + 1] = depths[i] + step * Math.sin(turn);
        }
        // Nuota sul posto, attorno al suo centro: piegarsi lo accorcia da entrambi i lati.
        const drift = ($078463d69a051bef$var$LENGTH - (xs[0] - xs[$078463d69a051bef$var$SAMPLES])) / 2;
        let middle = 0;
        for(let i = 0; i <= $078463d69a051bef$var$SAMPLES; i++)middle += depths[i];
        middle /= $078463d69a051bef$var$SAMPLES + 1;
        for(let i = 0; i <= $078463d69a051bef$var$SAMPLES; i++){
            xs[i] -= drift;
            depths[i] -= middle;
        }
        return this;
    }
    // Dove si vede adesso un punto del marchio piatto.
    project(px, py, out) {
        const at = Math.min(Math.max(($078463d69a051bef$var$NOSE - px) / $078463d69a051bef$var$LENGTH, 0), 1) * $078463d69a051bef$var$SAMPLES;
        const i = Math.min(Math.floor(at), $078463d69a051bef$var$SAMPLES - 1);
        const f = at - i;
        const x = this.xs[i] + (this.xs[i + 1] - this.xs[i]) * f;
        const depth = this.depths[i] + (this.depths[i + 1] - this.depths[i]) * f;
        // Visto un po' dall'alto, quello che è più vicino è anche più in basso.
        out[0] = x;
        out[1] = 512 + (py - 512) * (1 + depth / $078463d69a051bef$var$EYE) + depth * this.lift;
    }
}
const $078463d69a051bef$var$scratch = [
    0,
    0
];
function $078463d69a051bef$var$trace(ctx, pts, m, close) {
    for(let i = 0; i < pts.length; i++){
        let x = pts[i][0];
        let y = pts[i][1];
        if (m) {
            m.project(x, y, $078463d69a051bef$var$scratch);
            x = $078463d69a051bef$var$scratch[0];
            y = $078463d69a051bef$var$scratch[1];
        }
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    }
    if (close) ctx.closePath();
}
// Disegna il marchio in unità della griglia (la trasformazione la imposta chi chiama). m null = piatto.
function $078463d69a051bef$var$drawMark(ctx, m, paint = {}) {
    ctx.lineWidth = $078463d69a051bef$var$STROKE;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = paint.bones || $078463d69a051bef$var$INK.deep;
    ctx.beginPath();
    $078463d69a051bef$var$trace(ctx, $078463d69a051bef$var$TAIL, m, false);
    $078463d69a051bef$var$trace(ctx, $078463d69a051bef$var$HEAD, m, false);
    ctx.stroke();
    ctx.fillStyle = paint.ribs || $078463d69a051bef$var$INK.violet;
    ctx.beginPath();
    for (const rib of $078463d69a051bef$var$RIB_OUTLINES)$078463d69a051bef$var$trace(ctx, rib, m, true);
    ctx.fill();
}
// ===== Un solo ciclo di animazione per tutta la pagina =====
// Tutto quello che si muove si iscrive; senza iscritti, o con la scheda nascosta, non gira niente.
const $078463d69a051bef$var$subscribers = new Set();
let $078463d69a051bef$var$frame = 0;
let $078463d69a051bef$var$last = 0;
function $078463d69a051bef$var$loop(now) {
    // Una pausa lunga (scheda nascosta, debugger) non è un fotogramma lungo: i pesci non si teletrasportano.
    const dt = $078463d69a051bef$var$last ? Math.min((now - $078463d69a051bef$var$last) / 1000, 0.05) : 1 / 60;
    $078463d69a051bef$var$last = now;
    for (const tick of $078463d69a051bef$var$subscribers)tick(dt);
    $078463d69a051bef$var$frame = $078463d69a051bef$var$subscribers.size ? requestAnimationFrame($078463d69a051bef$var$loop) : 0;
    if (!$078463d69a051bef$var$frame) $078463d69a051bef$var$last = 0;
}
function $078463d69a051bef$var$subscribe(tick) {
    $078463d69a051bef$var$subscribers.add(tick);
    if (!$078463d69a051bef$var$frame) $078463d69a051bef$var$frame = requestAnimationFrame($078463d69a051bef$var$loop);
    return ()=>$078463d69a051bef$var$subscribers.delete(tick);
}
const $078463d69a051bef$var$reducedMotion = ()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// Un canvas grande quanto il suo box in px CSS, disegnato alla densità dello schermo.
function $078463d69a051bef$var$fitCanvas(canvas, width, height) {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    return dpr;
}
function $078463d69a051bef$var$whenVisible(el, onChange, margin = '120px') {
    const io = new IntersectionObserver((entries)=>{
        for (const e of entries)onChange(e.isIntersecting);
    }, {
        rootMargin: margin
    });
    io.observe(el);
    return ()=>io.disconnect();
}
// Un canvas nostro per elemento: il carosello clona le card via outerHTML e porta
// con sé il canvas serializzato (vuoto) dell'istanza precedente.
function $078463d69a051bef$var$ownCanvas(host) {
    host.querySelectorAll(':scope > canvas').forEach((old)=>old.remove());
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    host.appendChild(canvas);
    return canvas;
}
// ===== <nchova-fish>: il marchio che nuota sul posto =====
class $078463d69a051bef$var$NchovaFish extends HTMLElement {
    static get observedAttributes() {
        return [
            'size',
            'still'
        ];
    }
    connectedCallback() {
        if (!this.canvas || !this.canvas.isConnected) {
            this.canvas = $078463d69a051bef$var$ownCanvas(this);
            this.ctx = this.canvas.getContext('2d');
            this.midline = new $078463d69a051bef$var$Midline();
            this.phase = Math.random() * Math.PI * 2;
            this.drawn = 0;
        }
        this.layout();
        this.unobserve = $078463d69a051bef$var$whenVisible(this, (visible)=>visible ? this.start() : this.stop());
    }
    disconnectedCallback() {
        this.stop();
        this.unobserve?.();
    }
    attributeChangedCallback() {
        if (this.isConnected && this.canvas) {
            this.drawn = 0;
            this.layout();
        }
    }
    get size() {
        return Number(this.getAttribute('size')) || 24;
    }
    get still() {
        return this.hasAttribute('still') || $078463d69a051bef$var$reducedMotion();
    }
    layout() {
        const h = this.size;
        const w = h * $078463d69a051bef$var$BOX.w / $078463d69a051bef$var$BOX.h;
        if (Math.abs(h - this.drawn) < 0.5) return;
        this.drawn = h;
        this.dpr = $078463d69a051bef$var$fitCanvas(this.canvas, w, h);
        this.style.width = `${w}px`;
        this.style.height = `${h}px`;
        this.draw();
    }
    start() {
        if (this.unsubscribe) return;
        this.draw();
        if (this.still) return;
        this.unsubscribe = $078463d69a051bef$var$subscribe((dt)=>{
            this.phase += dt * Math.PI * 2 / $078463d69a051bef$var$IDLE.period;
            this.draw();
        });
    }
    stop() {
        this.unsubscribe?.();
        this.unsubscribe = null;
    }
    draw() {
        const { ctx: ctx, canvas: canvas } = this;
        const s = this.size / $078463d69a051bef$var$BOX.h * this.dpr;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.setTransform(s, 0, 0, s, -$078463d69a051bef$var$BOX.x * s, -$078463d69a051bef$var$BOX.y * s);
        const m = this.still ? null : this.midline.set(this.phase, $078463d69a051bef$var$IDLE.vigour, $078463d69a051bef$var$IDLE.elevation);
        $078463d69a051bef$var$drawMark(ctx, m, {
            bones: this.getAttribute('bones') || undefined,
            ribs: this.getAttribute('ribs') || undefined
        });
    }
}
// ===== <nchova-tank>: pesci che girano nel contenitore =====
// Vagano, girano prima dei bordi (di profilo si stringono fino a sparire e tornano
// dall'altra parte) e scappano dal puntatore. La coda batte quanto serve alla
// velocità: U ≈ 0,75 · L · f (Bainbridge).
const $078463d69a051bef$var$clamp = (v, lo, hi)=>Math.min(hi, Math.max(lo, v));
class $078463d69a051bef$var$Swimmer {
    constructor({ x: x, y: y, size: size, alpha: alpha = 1, paint: paint = {}, dir: dir }){
        this.x = x;
        this.y = y;
        this.size = size;
        this.cruise = this.length * 0.45;
        this.speed = this.cruise;
        this.alpha = alpha;
        this.paint = paint;
        this.dir = dir || (Math.random() < 0.5 ? 1 : -1);
        this.face = this.dir;
        this.pitch = 0;
        this.phase = Math.random() * Math.PI * 2;
        this.vigour = 1;
        this.t = Math.random() * 100;
        this.seeds = [
            Math.random() * 10,
            Math.random() * 10,
            Math.random() * 10
        ];
        this.cooldown = 0;
        this.idleTurn = 6 + Math.random() * 12;
        this.midline = new $078463d69a051bef$var$Midline();
    }
    // Lunghezza del corpo in px CSS.
    get length() {
        return this.size * $078463d69a051bef$var$LENGTH / $078463d69a051bef$var$BOX.h;
    }
    update(dt, world) {
        this.t += dt;
        const [a, b, c] = this.seeds;
        const L = this.length;
        const t = this.t;
        let pitchTarget = 0.32 * Math.sin(t * 0.37 + a) + 0.18 * Math.sin(t * 0.83 + b);
        let speedTarget = this.cruise * (0.75 + 0.5 * (0.5 + 0.5 * Math.sin(t * 0.29 + c)));
        let wantDir = this.dir;
        // Lontano da sopra e da sotto: un pesce non esce dall'acqua.
        const m = Math.max(L * 0.7, 30);
        if (this.y < m) pitchTarget = Math.max(pitchTarget, 0.5 * $078463d69a051bef$var$clamp((m - this.y) / m, 0, 1));
        if (this.y > world.h - m) pitchTarget = Math.min(pitchTarget, -0.5 * $078463d69a051bef$var$clamp((this.y - world.h + m) / m, 0, 1));
        if (this.x > world.w - m && this.dir > 0) wantDir = -1;
        if (this.x < m && this.dir < 0) wantDir = 1;
        this.idleTurn -= dt;
        if (this.idleTurn < 0) {
            this.idleTurn = 8 + Math.random() * 14;
            if (this.x > world.w * 0.25 && this.x < world.w * 0.75) wantDir = this.dir > 0 ? -1 : 1;
        }
        if (world.pointer) {
            const dx = this.x - world.pointer.x;
            const dy = this.y - world.pointer.y;
            const d = Math.hypot(dx, dy);
            const R = L * 1.3 + 70;
            if (d < R) {
                const fear = 1 - d / R;
                speedTarget = Math.max(speedTarget, this.cruise * (1 + 3.5 * fear));
                pitchTarget = $078463d69a051bef$var$clamp(pitchTarget + dy / R * 1.4 * fear, -0.65, 0.65);
                // Il puntatore è davanti: gira e scappa.
                if (dx * this.dir < 0 && fear > 0.25) wantDir = this.dir > 0 ? -1 : 1;
            }
        }
        this.cooldown -= dt;
        if (wantDir !== this.dir && this.cooldown <= 0) {
            this.dir = wantDir;
            this.cooldown = 1.4;
        }
        // Girarsi prende circa mezzo secondo.
        const step = dt * 3.2;
        this.face = this.dir > this.face ? Math.min(this.dir, this.face + step) : Math.max(this.dir, this.face - step);
        const turning = 1 - Math.abs(this.face);
        this.speed += (speedTarget * (1 - 0.6 * turning) - this.speed) * Math.min(1, dt * 1.6);
        this.pitch += (pitchTarget - this.pitch) * Math.min(1, dt * 1.3);
        this.x += this.face * Math.cos(this.pitch) * this.speed * dt;
        this.y += Math.sin(this.pitch) * this.speed * dt;
        // Una rete di sicurezza se il contenitore si restringe sotto il pesce.
        this.x = $078463d69a051bef$var$clamp(this.x, -L, world.w + L);
        this.y = $078463d69a051bef$var$clamp(this.y, 0, world.h);
        const beat = Math.max(this.speed / (0.75 * L), 1 / $078463d69a051bef$var$IDLE.period);
        this.phase += Math.PI * 2 * beat * dt;
        this.vigour = $078463d69a051bef$var$clamp(0.85 + 0.35 * (this.speed / this.cruise), 0.85, 1.7);
    }
    draw(ctx, still) {
        const s = this.size / $078463d69a051bef$var$BOX.h;
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.translate(this.x, this.y);
        ctx.scale(Math.sign(this.face || 1) * Math.max(Math.abs(this.face), 0.04), 1);
        ctx.rotate(this.pitch);
        ctx.scale(s, s);
        ctx.translate(-$078463d69a051bef$var$CENTRE.x, -$078463d69a051bef$var$CENTRE.y);
        $078463d69a051bef$var$drawMark(ctx, still ? null : this.midline.set(this.phase, this.vigour, $078463d69a051bef$var$IDLE.elevation), this.paint);
        ctx.restore();
    }
}
class $078463d69a051bef$var$NchovaTank extends HTMLElement {
    connectedCallback() {
        if (this.canvas && this.canvas.isConnected) return;
        this.canvas = $078463d69a051bef$var$ownCanvas(this);
        this.ctx = this.canvas.getContext('2d');
        this.swimmers = [];
        this.world = {
            w: 0,
            h: 0,
            pointer: null
        };
        this.w = 0;
        this.h = 0;
        this.still = $078463d69a051bef$var$reducedMotion();
        this.resizer = new ResizeObserver(()=>this.resize());
        this.resizer.observe(this);
        // Il canvas non riceve eventi: il puntatore lo si ascolta sul contenitore del banner.
        const area = this.parentElement || this;
        const toLocal = (event)=>{
            if (event.pointerType === 'touch') return;
            const r = this.canvas.getBoundingClientRect();
            this.world.pointer = {
                x: event.clientX - r.left,
                y: event.clientY - r.top
            };
        };
        area.addEventListener('pointermove', toLocal, {
            passive: true
        });
        area.addEventListener('pointerleave', ()=>this.world.pointer = null);
        if (this.still) return;
        this.unobserve = $078463d69a051bef$var$whenVisible(this, (visible)=>{
            if (visible && !this.unsubscribe) this.unsubscribe = $078463d69a051bef$var$subscribe((dt)=>this.frame(dt));
            if (!visible && this.unsubscribe) {
                this.unsubscribe();
                this.unsubscribe = null;
            }
        }, '0px');
    }
    disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribe = null;
        this.unobserve?.();
        this.resizer?.disconnect();
        this.canvas = null;
    }
    resize() {
        const r = this.getBoundingClientRect();
        const w = Math.round(r.width);
        const h = Math.round(r.height);
        if (!w || !h || w === this.w && h === this.h) return;
        const first = !this.swimmers.length;
        const sx = this.w ? w / this.w : 1;
        const sy = this.h ? h / this.h : 1;
        this.w = this.world.w = w;
        this.h = this.world.h = h;
        this.dpr = $078463d69a051bef$var$fitCanvas(this.canvas, w, h);
        if (first) this.populate();
        else for (const s of this.swimmers){
            s.x *= sx;
            s.y *= sy;
        }
        this.draw();
    }
    populate() {
        const count = Number(this.getAttribute('fish')) || 1;
        const biggest = Number(this.getAttribute('size')) || 34;
        // Dal più lontano al più vicino: i pesci piccoli sono più lontani e più chiari.
        this.swimmers = Array.from({
            length: count
        }, (_, i)=>{
            const size = biggest * (1 - 0.38 * i / Math.max(count - 1, 1));
            // Partono nella metà destra, dove il testo lascia acqua libera.
            return new $078463d69a051bef$var$Swimmer({
                x: this.w * (0.5 + 0.45 * Math.random()),
                y: this.h * (0.2 + 0.6 * Math.random()),
                size: size,
                alpha: 0.9 - 0.35 * i / Math.max(count - 1, 1)
            });
        }).sort((a, b)=>a.size - b.size);
    }
    frame(dt) {
        for (const s of this.swimmers)s.update(dt, this.world);
        this.draw();
    }
    draw() {
        const { ctx: ctx } = this;
        ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        ctx.clearRect(0, 0, this.w, this.h);
        for (const s of this.swimmers)s.draw(ctx, this.still);
    }
}
if ($078463d69a051bef$var$isMac) {
    if (!customElements.get('nchova-fish')) customElements.define('nchova-fish', $078463d69a051bef$var$NchovaFish);
    if (!customElements.get('nchova-tank')) customElements.define('nchova-tank', $078463d69a051bef$var$NchovaTank);
}
// ===== Copia il codice sconto =====
const $078463d69a051bef$var$COPIED_MS = 2200;
async function $078463d69a051bef$var$copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        // Fallback per contesti senza Clipboard API (http, permessi negati).
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        const ok = document.execCommand('copy');
        field.remove();
        return ok;
    }
}
document.addEventListener('click', async (event)=>{
    if (!$078463d69a051bef$var$isMac) return;
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;
    event.preventDefault();
    const code = button.dataset.copyCode;
    const label = button.querySelector('[data-copy-label]');
    const ok = await $078463d69a051bef$var$copyText(code);
    if (!ok) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'partner_click',
        partner: button.dataset.trackPartner || 'Nchova',
        link_url: `copia-codice:${code}`,
        page_path: window.location.pathname
    });
    if (!label) return;
    window.clearTimeout(button._copiedTimer);
    if (!label.dataset.idle) label.dataset.idle = label.textContent;
    label.textContent = 'Codice copiato';
    button.classList.add('is-copied');
    button._copiedTimer = window.setTimeout(()=>{
        label.textContent = label.dataset.idle;
        button.classList.remove('is-copied');
    }, $078463d69a051bef$var$COPIED_MS);
});


//# sourceMappingURL=s.eb812267.js.map
